const TmpL002 = (page, section) => {
  // pull images data from the page
  const images = [];
  const media = [];
  const eMentors = [];
  const modifiedPage = {
    ...page
  };

  page.content.core.forEach((objective, index) => {
    // modify the media object from the page data
    const objectiveMedia = {
      ...objective.media,
      id: page.id + '-' + index,
      page: page.id,
      src:
        page.label.toLowerCase().slice(0, -4).replaceAll('-', '_') +
        objective.tag.toLowerCase().replaceAll(' ', '_') +
        '.jpg',
      size: '900px X 900px'
    };
    // add the media object to the media array
    media.push(objectiveMedia);
    // modify the media object to strip out the unnecessary data
    delete objectiveMedia.author_desc_en;
    delete objectiveMedia.author_desc_tl;
    delete objectiveMedia.transcript;
    delete objectiveMedia.display_content;
    delete objectiveMedia.media_url;
    // push the modified media object to the images array
    images.push(objectiveMedia);
    // update the media object in te modified page data
    modifiedPage.content.core[index].media = objectiveMedia;

    modifiedPage.content.core[index].section_id = section.id;
  });

  // update the the ementor content with the page id
  if (page.content.eMentor) {
    page.content.eMentor.forEach((mentor) => {
      const eMentor = {
        ...mentor,
        page: page.id
      };
      eMentors.push(eMentor);
    });
  }

  // Inject page.id into each focus point if present
  if (page.content && Array.isArray(page.content.focus_points)) {
    page.content.focus_points.forEach((fp) => {
      fp.page = page.id;
    });
  }

  // Extract metadata separately
  const metadata = {
    media: media || [],
    images: images || [],
    materials: [],
    eMentor: eMentors,
    focusPoints: page.content.focus_points || []
  };

  return { modifiedPage, metadata };
};

export default TmpL002;
